import { render, staticRenderFns } from "./a.vue?vue&type=template&id=39b16ecc&scoped=true&"
import script from "./a.vue?vue&type=script&lang=js&"
export * from "./a.vue?vue&type=script&lang=js&"
import style0 from "./a.vue?vue&type=style&index=0&id=39b16ecc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b16ecc",
  null
  
)

export default component.exports